// wymaga użycia mixin "storeMixins"

const mixin = {
  methods: {
    getStationById(id) {
      return this.stations.find(s => s.id === id) || null;
    },
    getTrainCategory(id) {
      return this.trainCategories.find(category => category.id === id) || null;
    },
    trainCategoryFromName(name) {
      return this.trainCategories.find(category => category.name === name) || null;
    },
  },
};

export default mixin;
